import React from "react";
import StatusIndicator from "../status-indicator/status-indicator";
import ModelComponent from "../model-component/model-component.tsx";

const ModelComponentUserStatus = ({ userStatusId, statusTitle }) => {
  return (
    <ModelComponent
      modelId={userStatusId}
      colorBorderAccent="dark:border-color-dark-model-user-status border-color-model-user-status"
    >
      <StatusIndicator
        title={statusTitle}
        statusColor={"bg-color-status-good"}
      />
    </ModelComponent>
  );
};

export default ModelComponentUserStatus;
